










import { Component, Vue } from 'vue-property-decorator';
import {namespace} from 'vuex-class';

const AuthStore = namespace('AuthStore');

@Component({
  name: 'ErrorMessage',
})
export default class ErrorMessage extends Vue {
  @AuthStore.State
  public errorMessage!: string;
}
